import { Link } from 'react-router-dom'

export function Breadcrumbs({
  items,
}: {
  items: { label: string; to?: string }[]
}) {
  return (
    <nav className="mb-4 flex flex-wrap items-center gap-2 text-sm text-[var(--stryzh-color-text-secondary)]">
      {items.map((it, i) => (
        <span key={`${it.label}-${i}`} className="flex items-center gap-2">
          {i > 0 ? <span>/</span> : null}
          {it.to ? (
            <Link to={it.to} className="hover:text-[var(--stryzh-color-text-primary)]">
              {it.label}
            </Link>
          ) : (
            <span className="text-[var(--stryzh-color-text-primary)]">{it.label}</span>
          )}
        </span>
      ))}
    </nav>
  )
}
